import { createSelector } from '@reduxjs/toolkit';
import { LoadingStatuses } from '@packages/shared/core/common/entities';
import { RootInitialState } from '@packages/shared/core/common/store/rootReducer';

const selectSupportState = (state: RootInitialState) => state.support;

export const selectSupportSubmitStatus = createSelector(selectSupportState, (state) => state.submitStatus);

export const selectSupportError = createSelector(selectSupportState, (state) => state.error);

export const selectSupportSubmitSuccess = createSelector(
  selectSupportState,
  (state) => state.submitStatus === LoadingStatuses.FULFILLED,
);
